import React, { useMemo } from 'react';

import { Image, ImageProps } from 'expo-image';
import { ImageSourcePropType, ImageStyle, StyleProp } from 'react-native';

import { getImageAspectRatio } from './utils';

type FullWidthImageProps = ImageProps & {
  style?: StyleProp<ImageStyle>;
};

/** a full width image component that automatically determines its height */
export const FullWidthAutoHeightImage: React.FC<FullWidthImageProps> = ({
  source,
  style,
  ...rest
}) => {
  const aspectRatio = useMemo(() => getImageAspectRatio(source as ImageSourcePropType), [source]);

  const fullWidthStyle: StyleProp<ImageStyle> = [
    {
      width: '100%',
      ...(aspectRatio ? { aspectRatio } : {}),
    },
    style,
  ];

  return <Image source={source} style={fullWidthStyle} {...rest} />;
};

export default FullWidthAutoHeightImage;
